// Traduce "fa:users-gear" -> "fa-solid fa-users-gear"
// y da un fallback si el valor viene vacío o de otra librería.
export function iconToFA(icon) {
  if (!icon || typeof icon !== "string") return "fa-regular fa-circle-dot";
  const v = icon.trim();

  // Convención recomendada en BD: "fa:<nombre>"
  if (v.startsWith("fa:")) {
    const name = v.slice(3).trim(); // "users-gear"
    return `fa-solid fa-${name}`;
  }

  // Compatibilidad con valores antiguos (opcional: mapea lucide -> FA)
  if (v.startsWith("lucide:")) {
    // Aquí podrías mapear a equivalentes FA si los tienes definidos.
    return "fa-regular fa-square";
  }

  // Si te llega ya una clase completa, respétala.
  return v;
}
